// import {
//     useRecoilState,
//   } from 'recoil';
//import { themeState } from './themeState';
import Button from '@mui/material/Button';
import { useContext } from 'react';
import { ThemeContext } from '../App';
import LightModeIcon from '@mui/icons-material/LightMode';
import ModeNightIcon from '@mui/icons-material/ModeNight';

export default function ThemeToggle()
{
    const [currentTheme, setCurrentTheme] = useContext(ThemeContext);
    //const [currentTheme, setCurrentTheme] = useRecoilState(themeState);

    const toggle = () => {
        if(currentTheme === 'light')
            setCurrentTheme('dark');
        else
            setCurrentTheme('light');
    }
    return <>
        {currentTheme === 'light' ?
            <ModeNightIcon onClick={toggle}/>
            :
            <LightModeIcon onClick={toggle}/>
        }
    </>;
}